import React from 'react';
import { useTextFit } from '../hooks/useTextFit';

interface PrintPageProps {
  value: string;
  scale?: number;
}

export const PrintPage: React.FC<PrintPageProps> = ({ value, scale = 1.0 }) => {
  const { containerRef, textRef, fontSize } = useTextFit(value, {
    minFontSize: 20,
    maxFontSize: 800,
    scale
  });

  return (
    <div className="print-page bg-white text-black flex items-center justify-center p-8 border border-gray-200 overflow-hidden relative">
       {/* Container for text fitting */}
      <div 
        ref={containerRef} 
        className="w-full h-full flex items-center justify-center overflow-hidden"
      >
        <span 
          ref={textRef} 
          style={{ 
            fontSize: `${fontSize}px`, 
            lineHeight: 1.1, 
            whiteSpace: 'pre-wrap', 
            textAlign: 'center', 
            wordBreak: 'normal',
            overflowWrap: 'normal' 
          }}
        >
          {value}
        </span>
      </div>
      
      {/* Page number or identifier could be added here if needed */}
    </div>
  );
};
